module.exports = __webpack_public_path__ + "res/11-img_rewards_won.6c3d9c9db52f22c6a0a5931233284e43.png";